import { formatDateForToast } from 'utils/formatDate';
import { getFirstAndLastName } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { MainContainer } from 'v3/shared/components/Toast/ContractSignatureToast/styles';
import { LabelSmall } from 'v3/shared/typography/LabelSmall';

export const ContractSignatureToast = () => {
  const dateAndHour = useStoreSelector((store) => store.contracting.selectedContracting.contractSignDate);
  const sellerName = useStoreSelector((store) => store.seller.seller.name);

  return (
    <MainContainer>
      <LabelSmall>
        Contrato concluído em {formatDateForToast(dateAndHour)}
        {sellerName ? `, por ${getFirstAndLastName(sellerName)}` : '.'}
      </LabelSmall>
    </MainContainer>
  );
};
